import React from 'react'
import './Footer.css';

const Footer = () => {
  return (
    <div className="footer">
     <p>by Soul Group 2023</p>
    </div>
  )
}

export default Footer